<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app">
    <router-view class="mr-5" />
    <ProductFruits />
    <ContextMenu />
  </div>
</template>

<script>
import ProductFruits from './components/ProductFruits';
import ContextMenu from './components/context-menu/ContextMenu';

export default {
  components: {
    ProductFruits,
    ContextMenu,
  },
  watch: {
    '$vs.rtl'(val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr');
    },
  },
  mounted() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  async created() {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
  },
};
</script>

<style>
#app {
  color: #000000;
}
</style>
